// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__JzR3g","dragIcon":"Choice_dragIcon__3GJyN","left":"Choice_left__3I-A7","input":"Choice_input__3Vl0I"};